import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import styles from './TextContent.module.scss';

const components: JSXMapSerializer = {
  heading1: ({ children }) => <h2 className={styles.title}>{children}</h2>,
  paragraph: ({ children }) => <p className={styles.subtitle}>{children}</p>,
};

type Props = {
  slice: Content.EstimatePaymentSlice;
  isVisible: boolean;
};

export const TextContent: FC<Props> = ({ slice, isVisible }) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={styles.textWrapper}>
      <div className={`${styles.titleWrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={slice.primary.title} components={components} />
      </div>
      <div className={`${styles.subtitleWrapper} ${isVisibleStyles}`}>
        <PrismicRichText
          field={slice.primary.subtitle}
          components={components}
        />
      </div>
    </article>
  );
};
